export const ASIDE_WIDTH = 290;
export const FOOTER_HEIGHT = 72;
export const LAYOUT_GUTTER = 64;
export const NAV_HEIGHT = 80;
